function Loader({ fit }) {
  return (
    <section
      className={`loader-wrapper flex w-full flex-col items-center justify-center gap-10 ${
        fit ? "h-fit py-10" : "h-screen"
      }`}
    >
      <div className="spinner">
        <div />
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
      <p className="loader-brand">Our Matrix</p>
    </section>
  );
}

export default Loader;
